<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="8.828" height="14.828" viewBox="0 0 8.828 14.828" focusable="false" aria-hidden="true">
        <g transform="translate(-45.001 -39.026)">
            <line x2="6" y2="6" transform="translate(46.415 40.441)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2"/>
            <line y1="6" x2="6" transform="translate(46.415 46.441)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2"/>
        </g>
    </svg>
</template>